import GamePlaySound from "../static/audio/tapberry_gameplay_sound.mp3"
const gamePlayAudio = (new Audio(GamePlaySound))

export const backgroundMusicStart = () => {
    gamePlayAudio.volume = 0.4
    gamePlayAudio.loop = true
    gamePlayAudio.play()
}

export const backgroundMusicStop = () => {
    gamePlayAudio.pause()
}
